import { Button } from "@maker/design-system/ui/button";
import { Link } from "react-router";

const TranscriptionsTranscriptionErrorPage = () => {
	return (
		<section className="w-full max-w-120 p-6">
			<h2 className="font-semibold text-md">Erro</h2>

			<p className="mb-4 font-medium text-neutral-600 text-sm">
				Ocorreu um erro ao acessar a transcrição.
			</p>

			<div>
				<Button
					size="sm"
					variant="black"
					render={<Link to="/transcriptions">Voltar</Link>}
					nativeButton={false}
				></Button>
			</div>
		</section>
	);
};

export default TranscriptionsTranscriptionErrorPage;
